/**
 * виджет работы с формой поиска
 */
import {Widget} from "base/assets/js/widget/Widget.js";

export class FormSearch extends Widget{

	_aQuery = [];
	_sQSep = '_';

	run() {
		const sQuery = this._el( 'Query' ).value;
		let aQuery = sQuery.split( this._sQSep );
		this._aQuery = aQuery.filter( ( sItem ) => {
			return sItem !== '';
		} );
	}

	indexOfQueryItem( sQueryItem ) {
		for( let i = 0; i < this._aQuery.length; i++ ) {
			if( this._aQuery[ i ].substr( 1 ) === sQueryItem ) {
				return i;
			}
		}
		return -1;
	}

	isEmpty() {
		return this._aQuery.length === 0;
	}

	/**
	 * удаляем условие, например t123
	 * @param sQueryItem
	 */
	dropQueryItem( sQueryItem ) {
		const iIndex = this.indexOfQueryItem( sQueryItem );
		if( iIndex !== -1 ) {
			this._aQuery.splice( iIndex, 1 );
		}
		this._submit();
	}

	/**
	 * добавляем условие, с типом например it123
	 * @param {string} sQueryItemTyped
	 */
	addQueryItemTyped( sQueryItemTyped ) {

		// подменяем, если есть ti123, и приходит te123, надо оставить только te123
		let bSet = false;
		for( let i = 0; i < this._aQuery.length; i++ ) {
			if( sQueryItemTyped.substr( 2 ) === this._aQuery[ i ].substr( 2 ) ) {
				this._aQuery[ i ] = sQueryItemTyped;
				bSet = true;
				break;
			}
		}
		if( !bSet ) {
			this._aQuery.push( sQueryItemTyped );
		}
		this._submit();
	}

	_submit() {
		this._el( 'Query' ).value = this._aQuery.join( this._sQSep );
		if( this._fire( '', 'submit' ) ) {
			this.bl().submit();
		}
	}
}